import m from "../../geodata/es2015/turkeyLow";
window.am4geodata_turkeyLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/turkeyLow.js
// module id = null
// module chunks = 